import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class CalcsFilingGroupStatusService {

  constructor(private http: HttpClient) { }

  // Get from scenario - matches AngularJS getFromScenario
  getFromScenario(baseUrl: string, params: any): Observable<any> {
    const jcd_key = params.jcd_key || '250';
    const scenario = params.scenario || '';
    const tax_year = params.tax_year || '';
    
    const url = `${baseUrl}/loadJsonObject?action_code=7q0wiy&jcd_key=${jcd_key}&scenario=${scenario}&tax_year=${tax_year}`;
    
    return this.http.get<any>(url);
  }

  // Get from filing group - matches AngularJS getFromFilingGroup
  getFromFilingGroup(baseUrl: string, params: any): Observable<any> {
    const jcd_key = params.jcd_key || '250';
    const scenario = params.scenario || '';
    const tax_year = params.tax_year || '';
    
    const url = `${baseUrl}/loadJsonObject?action_id=762&jcd_key=${jcd_key}&scenario=${scenario}&tax_year=${tax_year}`;
    
    return this.http.get<any>(url);
  }

  // Save copy changes - matches AngularJS saveCopyChanges
  saveCopyChanges(baseUrl: string, params: any): Observable<any> {
    // 🚀 CRITICAL: Build params exactly like AngularJS service
    let finalParams: any = _.merge({}, params);
    
    // 🚀 CRITICAL: Add all required parameters with proper fallback chains
    finalParams.tax_year = params?.tax_year || params?.globalParams?.tax_year || '';
    finalParams.scenario = params?.scenario || params?.globalParams?.scenario || '';
    finalParams.jcd_key = params?.jcd_key || params?.globalParams?.jcd_key || '250';
    finalParams.screen_key = params?.screen_key || params?.globalParams?.screen_key || '';
    finalParams.jcd_ta_key = params?.jcd_ta_key || params?.globalParams?.jcd_ta_key || '';
    finalParams.activity_key = params?.activity_key || params?.globalParams?.activity_key || '';
    finalParams.screen_type = params?.screen_type || params?.globalParams?.screen_type || 'custom';
    finalParams.is_locked = params?.is_locked || params?.globalParams?.is_locked || 'N';
    finalParams.issue_id = params?.issue_id || params?.globalParams?.issue_id || '';
    finalParams.issue_short_desc = params?.issue_short_desc || params?.globalParams?.issue_short_desc || '';
    finalParams.issue_id_for_tx_save = params?.issue_id_for_tx_save || params?.globalParams?.issue_id_for_tx_save || '';
    finalParams.scenarioCode = params?.scenarioCode || params?.scenario_code || params?.globalParams?.scenarioCode || params?.globalParams?.scenario_code || 'RAF';
    finalParams.is_issue_key_enabled = params?.is_issue_key_enabled || params?.globalParams?.is_issue_key_enabled || 'N';
    
    // 🚀 CRITICAL: Ensure copy operation parameters are included
    finalParams.from_tax_year = params?.from_tax_year || '';
    finalParams.from_scenario = params?.from_scenario || '';
    finalParams.from_fg = params?.from_fg || '';
    finalParams.to_tax_year = params?.to_tax_year || '';
    finalParams.to_scenario = params?.to_scenario || '';
    finalParams.to_fg = params?.to_fg || '';
    
    const url = `${baseUrl}/saveJsonObject?action_code=0betp4`;
    
    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(finalParams).forEach(key => {
      if (finalParams[key] !== null && finalParams[key] !== undefined) {
        urlEncoded.set(key, finalParams[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}

